import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { DIC } from '../dic';

/**
 * Generated class for the NopayalarmPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-nopayalarm',
  templateUrl: 'nopayalarm.html',
})
export class NopayalarmPage {
  _suspend = 0

  constructor(public dic: DIC, public navCtrl: NavController, public navParams: NavParams) {
    this._suspend = navParams.get('suspend')
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad NopayalarmPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/nopayalarm/nopayalarm.ts